import VideoReferenceList from "./VideoReferenceList.vue";

export default VideoReferenceList;
